import { render, staticRenderFns } from "./DictionaryAcceptanceWords.vue?vue&type=template&id=47b66467&scoped=true&"
import script from "./DictionaryAcceptanceWords.vue?vue&type=script&lang=js&"
export * from "./DictionaryAcceptanceWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b66467",
  null
  
)

export default component.exports